<!--C2-迭代需求蔚来促销2110，-->

<template>
  <div class="collect-box">
    <img src="../../assets/image/CustomersInfo/weiLai.png" class="cover" alt="" />
    <div class="form-box ">
      <div class="title">
        <span class="line">——</span> 车家 蔚来ES6/EC6 融资租赁购车
        <span class="line">——</span>
      </div>
      <div class="form-item">
        <input v-model="form.name" placeholder="请输入姓名" type="text" class="input" maxlength="24" />
      </div>
      <div class="form-item">
        <input v-model="form.mobile" placeholder="请输入电话" type="tel" class="input" maxlength="11" />
      </div>
      <div class="form-item">
        <input v-model="form.vCode" placeholder="请输入验证码" type="text" class="input input-code" maxlength="6" />
        <button class="verify-code" @click="getVCode">{{ vCodeStr }}</button>
      </div>
      <div class="agree-box">
        <div :class="['check-btn', agreeFlag ? '' : 'check-un']" @click="agreeFlag = !agreeFlag">
          <img v-show="agreeFlag" src="../../assets/image/CustomersInfo/weiLai_ed.png" alt="" />
        </div>
        <div class="warning">
          您已阅读并同意
          <span class="blue" @click="visible = true">《用户隐私协议》</span>
        </div>
      </div>
      <div class="submit-btn" @click="formSubmit">立即订购</div>
    </div>
    <van-popup v-model="visible" position="bottom" :round="true" :overlay-style="popupStyle" :style="popupStyle">
      <div class="agreement">
        <img @click="visible = false" src="../../assets/image/CustomersInfo/close.png" class="close" alt="" />
        <div class="title">用户隐私协议</div>
        <div class="agreement-context" v-html="agreementCont"></div>
      </div>
    </van-popup>
  </div>

</template>

<script>
import common from '@/utils/common';
import constants from '@/utils/constants';
import { Popup, Toast } from 'vant';
import lodash from 'lodash';

const agreementCont =
  '上海有车有家融资租赁有限公司（“车家”）车家尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，车家会按照本隐私权保护协议的规定收集、使用和披露您的个人信息。但车家将以高度的勤勉、审慎义务对待这些信息。请您在使用本网站的特定服务之前，仔细阅读本隐私保护协议，做出您认为适当的选择，对于本协议中与您的权益存在重大关系的条款和个人敏感信息，我们将采用粗体字进行标注以提示您注意。您通过页面点击或其他方式确认同意说明您同意本隐私保护协议并同意本网站根据本隐私保护协议收集、使用、披露您的个人信息。车家会不时更新本隐私保护协议。您的下载、使用、登录等行为或同意车家相关协议之时，即视为您已经同意本隐私保护协议全部内容。\n' +
  '\n' +
  '一、信息的收集和使用\n' +
  '我们遵循“合法、正当、必要”的原则使用、存储和处理您的信息（包括个人信息），以提供、了解、改进和发展本平台 ，创建和维护一个受到信任的、更安全的环境，并遵守我们的法律义务。\n' +
  '（一）本平台向您必要性收集的信息\n' +
  '当您使用本平台时，我们要求您提供并收集以下您的个人信息。此等信息对于充分履行您和我们之间的约定的服务很有必要，并使得我们能够遵守我们的法律义务。没有此等信息，我们无法向您提供您所要求的全部服务。\n' +
  'a)账号信息。在您注册或登录本平台账号时，我们需要您提供（姓名、手机号码等）信息，以便我们能联系到您，更好地为您推荐和匹配产品服务需求。\n' +
  'b)网页记录。我们会留存您的网络日志信息。这是我们根据《网络安全法》等法律法规的要求必须收集的个人信息。如您拒绝提供上述信息，请您停止使用我们的服务。\n' +
  '（二）取得授权的例外\n' +
  '根据相关法律法规和国家标准，在以下情形中，我们收集、使用您的个人信息无需征得您的授权同意：\n' +
  'a)  与我们履行法律法规规定的义务相关的； \n' +
  'b)  与国家安全、国防安全直接相关的；\n' +
  'c)  与公共安全、公共卫生、重大公共利益直接相关的；\n' +
  'd)  与犯罪侦查、起诉、审判和判决执行等直接相关的； \n' +
  'e)  出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；\n' +
  'f)  所涉及的个人信息是您自行向社会公众公开的； \n' +
  'g)  从合法公开披露的信息中收集个人信息的,如合法的新闻报道、政府信息公开等渠道； \n' +
  'h)  用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障。\n' +
  '（三）个人信息使用规则\n' +
  '我们仅会按照本隐私保护协议规定的目的和范围收集和使用您的个人信息，当我们将您的个人信息用于本协议未载明的其它用途，会事先征求您的同意。\n' +
  '\n' +
  '二、 我们如何使用Cookie和同类技术\n' +
  '为确保网站正常运转，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。我们会通过Cookie标注您的浏览器的唯一性和在本网站的账户信息（包括您访问本网站的各项活动、浏览习惯、消费习惯、账户信息等）；您可以通过修改浏览器设置的方式拒绝Cookie，如果您拒绝了Cookie，您可能无法使用依赖于Cookie才能提供的本网站服务或功能；\n' +
  '\n' +
  '三、我们如何共享、转让、公开披露您的个人信息\n' +
  '（一）仅为实现本隐私保护协议中声明的目的，整合资源，我们可能会和指定第三方基于汽车相关服务、产品、买卖于必要范围内共享您的个人信息，以便共同向您提供更好的服务。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息，以提供更好的客户服务和用户体验。我们的指定第三方必须遵守我们的数据隐私和安全要求，并且无权将共享的个人信息用于与产品或服务无关的其他用途。\n' +
  '（二）在本平台服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。\n' +
  '（三）信息披露\n' +
  'a)我们不会将您的信息披露给不受信任的第三方。\n' +
  'b)根据法律的有关规定，或者行政或司法机构的强制性要求，向第三方或者行政、司法机构披露。\n' +
  '\n' +
  '四、信息存储和交换\n' +
  '在获得您的数据之后，我们会将其上传至服务器，以生成您的评估数据，以便您能够更好地获得服务。您上传的数据所生成的结果仅供参考，实际将以现场验收评估后的结果为准。我们在与您达成协议并取得您的同意之后，具体协议由车家或其指定的第三方与您签署。\n' +
  '\n' +
  '五、未成年人保护\n' +
  '除了适用法律要求外，我们不会在明知的情况下收集未成年人（未满十八周岁）的个人信息。十六周岁至十八周岁的未成年人使用本平台服务， 应当由监护人注册账户和填写相关信息。如未经其监护人同意，未成年人请勿向我们提供个人信息。\n' +
  '\n' +
  '六、信息安全\n' +
  '您不可避免的要向交易方或潜在的交易方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，请您立即联络车家客服，以便我们采取相应措施。\n' +
  '\n' +
  '七、隐私权政策的更新\n' +
  '（一）我们会适时更新本隐私权政策，以反映我们的操作实践、相关服务和法律法规的变化。未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。\n' +
  '（二）对于重大变更，我们还会提供更为显著的通知（如我们会通过短信、电子邮件或页面公告等方式进行通知）。\n' +
  '（三）本隐私权政策所指的重大变更包括但不限于：我们的服务模式发生重大变化；我们在所有权结构、组织架构等方面发生重大变化；个人信息共享、转让或公开披露的主要对象发生变化；您参与个人信息处理方面的权利及其行使方式发生重大变化；我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；个人信息安全影响评估报告表明存在高风险时。\n' +
  '（四）在该种情况下，若您继续使用我们的服务，即表示同意受经修订的政策约束。\n' +
  '\n' +
  '八、其他\n' +
  '（一）本协议签订地为上海市浦东新区。\n' +
  '（二）本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和大陆地区法律。\n' +
  '（三）若您和车家之间发生任何纠纷或争议，应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。\n' +
  '（四）本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。\n' +
  '（五）本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。\n';

/**
 * formData 表单数据
 * rules 验证规则
 */
const formVerify = (formData = {}, rules) => {
  for (const key in formData) {
    let rule = rules[key];
    if (Object.prototype.toString.call(rule) === '[object String]') {
      //只验证必填
      if (!formData[key]) {
        throw new Error(rules[key]);
      }
    } else if (typeof rule === 'function') {
      //通过方法回调
      let message = rule(formData[key]);
      if (message) {
        throw new Error(message);
      }
    }
  }
};

export default {
  data() {
    return {
      visible: false,
      agreementCont,
      form: {
        name: '',
        mobile: '',
        vCode: '',
      },
      agreeFlag: true,
      mobile: '',
      vCodeStr: '获取验证码',
      isActive: false,
    };
  },
  computed: {
    popupStyle() {
      let deviceWidth =
        document.documentElement.clientWidth || window.innerWidth;
      if (deviceWidth <= 750) {
        return {};
      }
      return {
        width: '7.5rem',
        left: '50%',
        transform: 'translateX(-50%)',
      };
    },
  },
  components: {
    Popup,
  },
  /**
   * 挂载
   */
  mounted() {
    this.wxShare();
    window.addEventListener('resize', function () {
      if (
        document.activeElement.tagName === 'INPUT' ||
        document.activeElement.tagName === 'TEXTAREA'
      ) {
        window.setTimeout(function () {
          if ('scrollIntoView' in document.activeElement) {
            document.activeElement.scrollIntoView();
          } else {
            document.activeElement.scrollIntoViewIfNeeded();
          }
        }, 0);
      }
    });
  },
  methods: {
    formSubmit() {
      const rules = {
        name: '请填写姓名',
        mobile: (val) => {
          if (!val) {
            return '请填写手机号码';
          }
          if (!/^1[0-9]{10}$/.test(val)) {
            return '手机号码格式错误';
          }
          return false;
        },
        vCode: '请填写验证码',
      };
      try {
        formVerify(this.form, rules);
        if (!this.agreeFlag) {
          throw new Error('请查看并同意隐私保护协议');
        }
        this.submitData();
      } catch (error) {
        Toast.fail(error.message);
      }
    },
    /**
     * 防止数据多次提交
     */
    submitData: lodash.throttle(function () {
      let that = this;
      let data = {
        name: that.form.name,
        mobilenumber: that.form.mobile,
        sourceType: '99',
        leadschannel: '蔚来促销2110',
      };

      that.$axios
        .get(
          '/admin/mobile/check/' + that.form.mobile + '?code=' + that.form.vCode
        )
        .then(function (res) {
          if (res.data.code == 0) {
            that.$axios
              .post('/c/crm/applyneworder', data)
              .then(function (res) {
                Toast.clear();
                that.$router.replace('/nio_success');
              })
              .catch((err) => {
                Toast.clear();
                common.tipToast(err.data.msg || '系统错误');
                return;
              });
          }
        })
        .catch((err) => {
          Toast.clear();
          common.tipToast(err.data.msg);
          return;
        });
    }, 1500),
    getVCode(e) {
      this.mobile = this.form.mobile;
      common.getVCodeAdmin(this, e, '?validTime=1');
    },
    wxShare() {
      common.wxShare(this, constants.NIO_SHAREINFO);
    },
  },
};
</script>

<style lang="less" scoped>
.flex() {
  display: -moz-box;
  /* Firefox */
  display: -ms-flexbox;
  /* IE10 */
  display: -webkit-box;
  /* Safari */
  display: -webkit-flex;
  /* Chrome, WebKit */
  display: box;
  display: flexbox;
  display: flex;
}

.collect-box {
  margin: 0 auto;
  width: 7.5rem;
  max-width: 7.5rem;
  min-height: 100vh;
  padding: 0px 0px 0.5rem 0;
  box-sizing: border-box;
  position: relative;
  &div {
    box-sizing: border-box;
  }
  .flex();
  flex-direction: column;
  align-items: center;
  .cover {
    width: 100%;
    height: auto;
  }
  .form-box {
    margin-top: -1.67rem;
    box-shadow: 2px 2px 25px 0 rgba(0, 0, 0, 0.1);
    width: 6.8rem;
    padding: 0.36rem 0.4rem;
    background: #fff;
    .flex();
    flex-direction: column;
    align-items: center;
    .title {
      font-family: PingFangSC-Regular;
      font-size: 0.3rem;
      color: #353d54;
      letter-spacing: 0;
      text-align: center;
      line-height: 0.6rem;
      height: 0.6rem;
      position: relative;
      margin-bottom: 0.15rem;
      .line {
        color: #353d54;
      }
    }
    .form-item {
      width: 100%;
      margin-top: 0.26rem;
      border-bottom: 0.01rem solid rgba(228, 228, 228, 0.3);
      padding: 0rem 0 0.14rem 0;
      position: relative;
      .flex();
      justify-content: space-between;
      align-items: center;
      &:first-child {
        margin-top: 0.41rem;
      }

      .input {
        .flex();
        flex-flow: 1;
        width: 6rem;
        height: 0.6rem;
        font-family: PingFangSC-Regular;
        font-size: 0.3rem;
        line-height: 0.6rem;
        color: #333;
        letter-spacing: 0;
        outline: none;
        background-color: transparent;
        border: none;
        -moz-appearance: textfield;
        &::-webkit-outer-spin-button {
          -webkit-appearance: none;
          appearance: none;
          margin: 0;
        }
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          appearance: none;
          margin: 0;
        }
        &::placeholder {
          color: rgba(201, 201, 201, 0.6);
        }
      }

      .input-code {
        width: 4.3rem;
      }

      .verify-code {
        font-family: PingFangSC-Regular;
        font-size: 0.3rem;
        color: #353d50;
        letter-spacing: 0;
        min-width: 1.5rem;
        text-align: center;
        cursor: pointer;
        background-color: transparent;
        border: none;
      }
    }

    .agree-box {
      width: 100%;
      padding: 0.3rem 0.15rem;
      .flex();
      align-items: center;
      .check-btn {
        margin-left: 0.74rem;
        width: 0.44rem;
        height: 0.44rem;
        cursor: pointer;
        border-radius: 50%;
        .flex();
        img {
          width: 0.44rem;
          height: 0.44rem;
        }
      }

      .check-un {
        border: 1px solid #979797;
      }

      .warning {
        font-family: PingFangSC-Regular;
        font-size: 0.26rem;
        color: #6d6f73;
        white-space: nowrap;
        padding-left: 0.14rem;
        .blue {
          color: #343333;
          cursor: pointer;
        }
      }
    }

    .submit-btn {
      width: 6rem;
      height: 0.9rem;
      cursor: pointer;
      background: #343333;
      font-family: PingFangSC-Regular;
      font-size: 0.32rem;
      line-height: 0.9rem;
      text-align: center;
      color: #ffffff;
      text-align: center;
      margin-top: 0.23rem;
    }
  }
}

.agreement {
  width: 100%;
  max-height: 75vh;
  padding: 0.25rem;
  position: relative;
  .flex();
  flex-direction: column;
  .agreement-context {
    .flex();
    flex-grow: 1;
    width: 100%;
    overflow-y: auto;
    box-sizing: border-box;
    font-family: PingFangSC-Regular;
    font-size: 0.26rem;
    color: #666;
    line-height: 0.36rem;
    white-space: pre-wrap;
    text-indent: 2em;
    text-align: justify;
  }

  .title {
    width: 100%;
    padding: 0.26rem 0;
    font-family: PingFangSC-Regular;
    font-size: 0.42rem;
    font-weight: 600;
    color: #333;
    line-height: 0.52rem;
  }

  .close {
    position: absolute;
    top: 0.26rem;
    right: 0.26rem;
    cursor: pointer;
    width: 0.48rem;
    height: 0.48rem;
  }
}

.popup-center {
  width: 7.5rem;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/WeiLai/WeiLai.vue